import FullProfileRequestListPageReducer from './FullProfileRequestListPageReducer';

export default from './FullProfileRequestListPageContainer';

export const FullProfileRequestListPageReducers = {
  FullProfileRequestListPageReducer,
};
